export default "__VITE_ASSET__cc3eb573__"